import { isEmbedMode } from "./embedMode";

export type EmbedHost = "admin" | "partner";

const STORAGE_KEY = "_zenvoya_embed_host";

const isEmbedHost = (value: unknown): value is EmbedHost =>
  value === "admin" || value === "partner";

export const setEmbedHost = (value: unknown): void => {
  if (typeof window === "undefined") return;
  if (!isEmbedMode()) return;
  try {
    if (isEmbedHost(value)) window.sessionStorage.setItem(STORAGE_KEY, value);
    else window.sessionStorage.removeItem(STORAGE_KEY);
  } catch {
  }
};

export const getEmbedHost = (): EmbedHost | null => {
  if (typeof window === "undefined") return null;
  try {
    const value = window.sessionStorage.getItem(STORAGE_KEY);
    return isEmbedHost(value) ? value : null;
  } catch {
    return null;
  }
};

export const isPartnerHost = (): boolean => getEmbedHost() === "partner";
